import { HttpClientError } from '../../../controllers/http-client/http-client';
import i18n from '../../../i18n';

export class PlaybackError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class ConcurrencyError extends PlaybackError {
  constructor() {
    super(i18n.t('concurrency message1'));
  }
}

export class MaxPlaybackSessionsError extends PlaybackError {
  constructor(code: string, message: string) {
    super(`${code} - ${message}`);
  }
}

export class GeoBlockedError extends PlaybackError {
  constructor() {
    super(i18n.t('player:geolocked_playback'));
  }
}

export class NotSubscribedError extends PlaybackError {
  constructor() {
    super(i18n.t('player:not_subscribed'));
  }
}

export class NotAllowedError extends PlaybackError {
  constructor() {
    super(i18n.t('player:content_not_allwed'));
  }
}

export class AuthorizationFailedError extends PlaybackError {
  constructor() {
    super(i18n.t('player:authorization_failed'));
  }
}

export class UnknownPlayerError extends PlaybackError {
  constructor(code: string, message: string) {
    super(`${code} - ${message}`);
  }
}

export class MissingMediaError extends PlaybackError {
  constructor(mediaType: 'media' | 'clip') {
    super(`No ${mediaType} found`);
    this.name = 'MissingMediaError';
  }
}

export class HttpPlaybackError extends PlaybackError {
  public code: string;
  constructor(error: HttpClientError) {
    let message: string;

    switch (error.code) {
      case 'C07':
        message = i18n.t('concurrency message1');
        break;
      case 'C13':
        message = i18n.t('player:geolocked_playback');
        break;
      default:
        message = error.message;
    }

    super(message);

    this.code = error.code;
    this.name = 'HttpPlaybackError';
  }
}
